export const fileStatuses = {
  awaitingScan: 'AwaitingScan',
  passedScan: 'PassedScan',
  failedScan: 'FailedScan',
  corrupt: 'Corrupt',
};
